import { environment } from 'src/environments/environment';

const POLYGONSCAN_MAINNET_URL = 'https://polygonscan.com';
const POLYGONSCAN_AMOY_URL = 'https://amoy.polygonscan.com';

type ExplorerPathType = 'tx' | 'address';

const normalizeUrl = (url: string): string => url.replace(/\/+$/, '');

const isMainnetExplorerEnvironment = (): boolean => {
    const envName = String(environment.ENVNAME || '').trim().toLowerCase();
    return ['staging', 'pre-production', 'pre_production', 'production'].includes(envName);
};

export const getExplorerBaseUrl = (chainId?: string | null): string => {
    if (isMainnetExplorerEnvironment()) {
        return POLYGONSCAN_MAINNET_URL;
    }

    const configuredExplorer = chainId ? (environment as any)[chainId]?.EXPLORER : undefined;
    const fallbackExplorer = (environment as any)[environment.DEFAULT_CHAIN]?.EXPLORER;
    const explorer = normalizeUrl(String(configuredExplorer || fallbackExplorer || POLYGONSCAN_MAINNET_URL));

    if (chainId === '0x13882') {
        return POLYGONSCAN_AMOY_URL;
    }

    return explorer;
};

const buildExplorerUrl = (pathType: ExplorerPathType, value?: string | null, chainId?: string | null): string => {
    if (!value) {
        return '';
    }

    return `${getExplorerBaseUrl(chainId)}/${pathType}/${value}`;
};

export const getExplorerTransactionUrl = (transactionHash?: string | null, chainId?: string | null): string => {
    return buildExplorerUrl('tx', transactionHash, chainId);
};

export const getExplorerAddressUrl = (address?: string | null, chainId?: string | null): string => {
    return buildExplorerUrl('address', address, chainId);
};
